import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { marked } from 'marked';
import { UserService } from 'app/service/user.service';

type PageState = 'loading' | 'ready' | 'missing';

// Öffentliche Rechtstexte (/terms, /imprint) aus den versionierten Dokumenten. Deutsch ist massgebend.
@Component({
  standalone: false,
  selector: 'app-legal-document',
  templateUrl: './legal-document.component.html',
  styleUrls: ['./legal-document.component.scss']
})
export class LegalDocumentComponent implements OnInit {
  state: PageState = 'loading';
  docType = 'terms_of_use';
  titleKey = 'legalPages.terms';
  html = '';
  version = '';
  publishedAt: Date | null = null;
  isTranslation = false;
  usesFallback = false;
  selectedLanguage = 'en';

  supportedLanguages: { code: string; name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];

  constructor(private route: ActivatedRoute, private translate: TranslateService, private userService: UserService) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.docType = this.route.snapshot.data['docType'] || this.docType;
    this.titleKey = this.route.snapshot.data['titleKey'] || this.titleKey;
    const stored = localStorage.getItem('selectedLanguage');
    this.selectedLanguage = this.supportedLanguages.some(l => l.code === stored) ? (stored as string) : 'en';
    this.translate.use(this.selectedLanguage);
    this.load();
  }

  get published(): string {
    return this.publishedAt
      ? new Intl.DateTimeFormat(this.selectedLanguage, { month: 'long', year: 'numeric' }).format(this.publishedAt)
      : '';
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
    this.load();
  }

  private load() {
    this.state = 'loading';
    this.userService.getLegalDocument(this.docType, this.selectedLanguage).subscribe(
      doc => {
        this.html = marked.parse(doc.text || '', { gfm: true, breaks: false }) as string;
        this.version = doc.version;
        this.publishedAt = doc.published_at ? new Date(doc.published_at) : null;
        this.isTranslation = !!doc.is_translation;
        // Es gibt noch keine Übersetzung in der gewählten Sprache: das deutsche Original wird gezeigt
        this.usesFallback = doc.language !== doc.requested_language;
        this.state = doc.text ? 'ready' : 'missing';
      },
      () => (this.state = 'missing')
    );
  }
}
